import { formatTime } from 'utilities/calendarFunctions';

export interface HourRowProps {
	hour: number | string;
	hourHeight: number | string;
	scope: 'week' | 'day' | string;
}

export default function HourRow(props: HourRowProps) {
	const {
		hour,
		hourHeight,
		scope
	} = props;

	const hourBody = () => {
		if (scope === 'week') {
			return (
				<div className="days-cols">
					<div className="day-col day-weekend visual-hour"></div>
					<div className="day-col visual-hour"></div>
					<div className="day-col visual-hour"></div>
					<div className="day-col visual-hour"></div>
					<div className="day-col visual-hour"></div>
					<div className="day-col visual-hour"></div>
					<div className="day-col day-weekend visual-hour"></div>
				</div>
			);
		} else {
			return <div className="day-col visual-hour"></div>;
		}
	};

	return (
		<div className="calendar-row calendar-hour-row" style={{ height: hourHeight }}>
			<div className="align-right hour-marker-col">{formatTime(hour, false, true)}</div>
			{hourBody()}
		</div>
	);
}